import styled, { keyframes } from 'styled-components';

import { ColorPath } from '../ui/colors';
import { theme } from '../ui/theme';

const position = keyframes`
    0% {
        left: -80%;
    }
    50% {
        left: 100%;
    }
    100% {
        left: -80%;
    }
`;

const forwardOpacity = keyframes`
    0% {
        opacity: 1;
    }
    50% {
        opacity: 1;
    }
    50.01% {
        opacity: 0;
    }
    100% {
        opacity: 0;
    }
`;

const backwardOpacity = keyframes`
    0% {
        opacity: 0;
    }
    50% {
        opacity: 0;
    }
    50.01% {
        opacity: 1;
    }
    100% {
        opacity: 1;
    }
`;

const LoadingBarContainer = styled.div`
    width: 100%;
    height: 4px;
    background-color: ${theme.colors.background.inset};
    border-radius: 100px;
    overflow: hidden;
    position: relative;
`;

interface LoadingBarForwardBackwardProps {
    $color: ColorPath;
}

const getThemeColor = (colorPath: ColorPath) => {
    const [groupKey, shadeKey] = colorPath.split('.') as [keyof typeof theme.colors, string | undefined];
    const group = theme.colors[groupKey];

    if (typeof group === 'string') {
        return group;
    }

    return group[shadeKey as keyof typeof group];
};

const LoadingBarForward = styled.div<LoadingBarForwardBackwardProps>`
    position: absolute;
    top: 0;
    width: 80%;
    height: 100%;
    background: linear-gradient(90deg, transparent 0%, ${({ $color }) => getThemeColor($color)} 100%);
    animation:
        ${position} 1.5s linear infinite,
        ${forwardOpacity} 1.5s linear infinite;
`;

const LoadingBarBackward = styled.div<LoadingBarForwardBackwardProps>`
    position: absolute;
    top: 0;
    width: 80%;
    height: 100%;
    background: linear-gradient(90deg, ${({ $color }) => getThemeColor($color)} 0%, transparent 100%);
    animation:
        ${position} 1.5s linear infinite,
        ${backwardOpacity} 1.5s linear infinite;
`;

interface LoadingBarProps {
    color?: ColorPath;
}

export const LoadingBar = ({ color = 'accent.emphasis' }: LoadingBarProps) => {
    return (
        <LoadingBarContainer>
            <LoadingBarForward $color={color} />
            <LoadingBarBackward $color={color} />
        </LoadingBarContainer>
    );
};
